import { RichiestaModuloDTOPermessiItem } from '@framework/api-client';
import { IModuleStateMachineRecord } from './ModuleStateMachine';

/**
 * Ritorna vero se l'utente ha i permessi per eseguire l'azione.
 */
export function hasActionPermission(
  record: IModuleStateMachineRecord,
  permissions: RichiestaModuloDTOPermessiItem,
) {
  return Boolean(record.module?.permessi?.includes(permissions));
}
